var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPromotionGreen = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_23",
  "data-name": "Group 23",
  transform: "translate(-36 -2812)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ANALYST_CONFIGURATION",
  transform: "translate(443 1255)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 34,
  height: 34,
  transform: "translate(-407 1557)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_22",
  "data-name": "Group 22",
  transform: "translate(84.966 86.823)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_21",
  "data-name": "Group 21",
  transform: "translate(-46.371 2728)"
}, /*#__PURE__*/React.createElement("g", {
  id: "promotion",
  transform: "translate(0 11.112)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M50.752,21a5.394,5.394,0,0,1,.969.41,1.912,1.912,0,0,1,.848,1.676q.008,6.119,0,12.238A2.061,2.061,0,0,1,51.3,37.26a1.991,1.991,0,0,1-2.28-.536,4.466,4.466,0,0,1-.459-.823,1.964,1.964,0,0,0-.234-.4,6.735,6.735,0,0,0-2.268-1.678,6.846,6.846,0,0,0-3.133-.49v.24c0,1-.017,1.991,0,2.986a2.087,2.087,0,0,1-1.786,2.2c-.014,0-.026.015-.038.023h-.455a4.337,4.337,0,0,1-.643-.207,2.017,2.017,0,0,1-1.176-1.925c-.007-1.079,0-2.157,0-3.236a.273.273,0,0,0-.186-.3,1.863,1.863,0,0,1-.967-.954.317.317,0,0,0-.331-.222,2.734,2.734,0,0,1,.044-5.465.31.31,0,0,0,.232-.109A2.089,2.089,0,0,1,39.7,25.1c1.266.009,2.532,0,3.8,0a6.45,6.45,0,0,0,2.751-.606,6.661,6.661,0,0,0,2.064-1.579,1.066,1.066,0,0,0,.233-.4,2.248,2.248,0,0,1,.5-.882A2.356,2.356,0,0,1,50.25,21C50.418,21,50.585,21,50.752,21Zm-2.3,12.717V24.693a7.533,7.533,0,0,1-4.151,1.744v5.539A7.548,7.548,0,0,1,48.456,33.717Zm-5.547-1.778V26.474c-1.159,0-2.3-.007-3.445,0a.645.645,0,0,0-.63.655q-.012,2.072,0,4.145a.645.645,0,0,0,.629.656C40.606,31.946,41.75,31.938,42.909,31.938Zm8.3-2.732V23.235c0-.547-.252-.865-.683-.865s-.682.318-.682.865V35.179a2.3,2.3,0,0,0,.006.251.68.68,0,0,0,1.353,0,2.3,2.3,0,0,0,.006-.251ZM40.2,33.319c0,1.171-.007,2.322.005,3.473a.614.614,0,0,0,.425.568.678.678,0,0,0,.929-.672c.006-1.009,0-2.018,0-3.027v-.344Zm-2.743-5.47A1.362,1.362,0,0,0,36.1,29.3a1.317,1.317,0,0,0,1.351,1.242Z",
  transform: "translate(-34.731 -21)",
  fill: "#5f7278"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M387.161,165.748a.855.855,0,0,1-.915.507c-.574-.023-1.151,0-1.726-.006a.688.688,0,1,1,0-1.367c.575,0,1.151.017,1.726-.006a.855.855,0,0,1,.915.507Z",
  transform: "translate(-363.86 -156.675)",
  fill: "#5f7278"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M373.71,92.36a.8.8,0,0,1,.651.445.656.656,0,0,1-.142.756c-.31.323-.63.636-.946.952-.145.145-.284.3-.437.431a.669.669,0,0,1-.943-.017.662.662,0,0,1-.013-.944q.684-.716,1.4-1.4A1.788,1.788,0,0,1,373.71,92.36Z",
  transform: "translate(-352.485 -88.293)",
  fill: "#5f7278"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M373.68,215.729a1.723,1.723,0,0,1-.409-.237c-.451-.427-.887-.871-1.322-1.317a.682.682,0,1,1,.958-.968q.675.66,1.334,1.336a.651.651,0,0,1,.145.774A.735.735,0,0,1,373.68,215.729Z",
  transform: "translate(-352.518 -202.042)",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(15.954)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_14",
  "data-name": "Ellipse 14",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.429,
  cy: 6.429,
  r: 6.429,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.429,
  cy: 6.429,
  r: 5.679,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-check",
  "data-name": "Icon awesome-check",
  d: "M2.446,9.842.105,7.5a.36.36,0,0,1,0-.509l.509-.509a.36.36,0,0,1,.509,0L2.7,8.059,6.077,4.683a.36.36,0,0,1,.509,0l.509.509a.36.36,0,0,1,0,.509L2.955,9.842A.36.36,0,0,1,2.446,9.842Z",
  transform: "translate(2.828 -0.833)",
  fill: "#5f7278"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPromotionGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_promotion_ green.6e8e7a03f8569b2016a3392886cc7477.svg";